import { render, staticRenderFns } from "./uploadReceipts.vue?vue&type=template&id=2bf95cfa&scoped=true&"
import script from "./uploadReceipts.vue?vue&type=script&lang=js&"
export * from "./uploadReceipts.vue?vue&type=script&lang=js&"
import style0 from "./uploadReceipts.vue?vue&type=style&index=0&id=2bf95cfa&prod&lang=scss&"
import style1 from "./uploadReceipts.vue?vue&type=style&index=1&id=2bf95cfa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf95cfa",
  null
  
)

export default component.exports